import Translate from '../icons/Translate'
import React, { useEffect, useState, useMemo } from 'react'
import Loader from './Loader'
interface Props {
  message: string
  author: string
  groupMessageType: 'first' | 'last' | 'middle' | 'single'
  translateMessage: (messageId: number, message: string) => void
  id: number
  translated: boolean
}

const ReceivedMessage = ({ message, author, groupMessageType, translateMessage, id, translated }: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    setIsLoading(false)
  }, [message, translated])

  const showAuthor = groupMessageType === 'single' || groupMessageType === 'first'
  const borderStyles = useMemo(() => {
    if (groupMessageType === 'first') return 'rounded-bl-none'
    if (groupMessageType === 'last') return 'rounded-tl-none'
    if (groupMessageType === 'middle') return 'rounded-l-none'
    return 'rounded-2xl'
  }, [groupMessageType])

  return (
    <div className="px-2">
      {showAuthor && (
        <>
          <p className="text-14 text-lightGray ml-1">{author}</p>
          <div className="h-1" />
        </>
      )}
      <div className="flex items-center">
        <div className={`bg-white rounded-2xl p-2 text-black text-14 max-w-[80%] ${borderStyles}`}>{message}</div>
        <div
          onClick={() => {
            setIsLoading(true)
            translateMessage(id, message)
          }}
          className={`w-9  h-5 ${translated ? 'text-darkRed' : 'text-slateGray'} ml-1 cursor-pointer`}>
          {isLoading ? <Loader isLoading /> : <Translate />}
        </div>
      </div>
      <div className="h-2" />
    </div>
  )
}

export default ReceivedMessage
